import { IApplication } from '../../api/models';
import React, { useEffect } from 'react';
import { AccordionWrapper } from '../UIExtentions/Accordion';
import ApplicationsTable from '../Applications/ApplicationsTable';
import { ApplicationTableButtons, ApplicationTableColumns } from '../../constants/ApplicationTableItems';

interface WebSiteApplicationListingViewProps {
    webSiteName: string;
    applications: IApplication[];
    isLoading: boolean;
    errorMessage: string;
    isDataNotFound: boolean;
}

export const WebSiteApplicationListingView = (props: WebSiteApplicationListingViewProps) => {
    const [applications, setApplications]: [IApplication[], Function] = React.useState(props.applications);
    const webSiteName = props.webSiteName;
    const hiddenButtons: [columnNames: ApplicationTableButtons] = [ApplicationTableButtons.Delete];
    const hiddenColumns: [columnNames: ApplicationTableColumns] = [ApplicationTableColumns.Type];

    useEffect(() => {
        const local = [...props.applications];
        setApplications(local);
    }, [props.applications]);

    return (
        <>
            <AccordionWrapper
                isDefaultOpen={false}
                headerIconType="fa-solid"
                headerIcon="fa-window-maximize"
                headerText="Virtual Apps"
                objectName={webSiteName}
                isLoading={props.isLoading}
                errorMessage={props.errorMessage}
                fitToSize={true}
            >
                <ApplicationsTable data={applications} maxHeight={250} hiddenButtons={hiddenButtons} hiddenColumns={hiddenColumns} isLoading={props.isLoading} />
            </AccordionWrapper>
        </>
    );
};
